import React from 'react';

import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';

import { UiButton, UiText } from '@shared/ui';

import cls from './EmptyTeam.module.css';

interface EmptyTeamProps {
    onClick: () => void;
    classes?: string;
}

export const EmptyTeam = ({ onClick, classes }: EmptyTeamProps) => {
    const { t } = useTranslation();

    return (
        <div className={classNames(cls.EmptyTeam, [classes])}>
            <div className={cls.content}>
                <UiText align="center" variant="mediumPlain">
                    <Trans i18nKey="EmptyTeam.content.UiText" />
                </UiText>
                <UiButton btnText={t('EmptyTeam.content.UiButton')} onClick={onClick} data-hint-target="invite-colleague-btn" />
            </div>
        </div>
    );
};
